// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsListFeature":"wo_a bhs_b","TwoDimsListFeature__item":"wo_b bhs_ux","TwoDimsListFeature__item__text":"wo_c bhs_un"};